import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ValidationService} from '../../services/validation.service';
import {FieldService} from '../../services/field.service';

@Component({
  selector: 'si-multiline',
  templateUrl: './multiline.component.html',
  styleUrls: ['./multiline.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultilineComponent implements AfterViewInit {
  @Input() text: string;
  @Input() placeholder: string;
  @Input() styleClass: string;
  @Input() id: string;
  @Input() name: string;
  @Input() disabled: boolean;
  @Input() rule: string;
  @Input() validationExternalErrorText: string;
  @Input() model: string;
  @Input() rows: number;
  @Input() tooltipText: string;
  @Input() tooltipPosition: string;
  @Input() tooltipIcon: string;
  @Input() tooltipStyleClass: string;
  @Input() tooltipEscape = true;
  @Input() forceShowTooltipIcon: boolean;
  @Input() hideLabel = false;
  @Output() modelChange = new EventEmitter<string>();
  @Output() blurChange = new EventEmitter<Event>();
  @Output() tooltipIconClick = new EventEmitter<any>();
  showRuleErrorOutsideIcon: boolean;
  validationErrorText: string;
  updateNgModelOnBlur: boolean;

  constructor(
    private el: ElementRef,
    private validationService: ValidationService,
    private fieldService: FieldService
  ) {
    this.setLogic();
  }

  ngAfterViewInit(): void {
    const parentWithClass = this.el.nativeElement.closest('.readmode');

    if (parentWithClass) {
      this.disabled = true;
    }
  }

  setLogic(): void {
    this.showRuleErrorOutsideIcon = this.validationService.getShowRuleErrorOutsideIcon();
    this.updateNgModelOnBlur = this.fieldService.getMultilineUpdateNgModelOnBlur();
  }

  onChangeModel(model: string): void {
    // Back webservices do not accept empty model.
    if (model === '') {
      model = undefined;
    }

    this.modelChange.emit(model);
  }

  onBlur(event: Event): void {
    this.blurChange.emit(event);
  }

  onClickTooltipIcon(event: any): void {
    this.tooltipIconClick.emit(event);
  }
}
